// src/components/admin/AccDashboardTile.js
import React, { useState, useEffect } from 'react';
import { ClipboardCheck, Loader, ArrowRight } from 'lucide-react';
import { supabase } from '../../lib/supabase';
import { useHOA } from '../../contexts/HOAContext';

const AccDashboardTile = ({ onNavigateToMessages }) => {
  const { hoa } = useHOA();
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        if (!hoa?.id) return;
        const { count, error } = await supabase
          .from('message_threads')
          .select('id', { count: 'exact', head: true })
          .eq('hoa_id', hoa.id)
          .eq('type', 'acc')
          .in('status', ['submitted', 'under_review', 'additional_info_required']);

        if (error) throw error;
        setTotal(count || 0);
      } catch (err) {
        console.error('AccDashboardTile load error:', err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [hoa?.id]);

  return (
    <button
      onClick={() => onNavigateToMessages?.()}
      className="w-full text-left bg-white rounded-2xl border border-slate-200/60 shadow-sm p-6 hover:border-amber-200 hover:shadow-md transition-all group"
    >
      {/* Header */}
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 rounded-lg bg-amber-50">
          <ClipboardCheck className="w-5 h-5 text-amber-700" />
        </div>
        <div>
          <h3 className="font-display font-bold text-slate-900 text-base">ACC Applications</h3>
          <p className="text-xs text-slate-500">Architectural Control Committee</p>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center py-4">
          <Loader className="w-5 h-5 animate-spin text-slate-300" />
        </div>
      ) : (
        <div className="flex items-center justify-between">
          <div>
            <span className="text-3xl font-bold text-amber-700">{total}</span>
            <span className="ml-2 text-sm text-slate-500">active application{total !== 1 ? 's' : ''}</span>
          </div>
          <ArrowRight className="w-5 h-5 text-slate-300 group-hover:text-amber-600 group-hover:translate-x-1 transition-all" />
        </div>
      )}
    </button>
  );
};

export default AccDashboardTile;
